/* eslint-disable react/prop-types */
import React, { useRef, useCallback, useEffect, useState } from 'react'
import { useSelector, shallowEqual } from 'react-redux'
import { useMergeState } from 'irmlib/hooks'
import { useHistory, Link } from 'react-router-dom'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { appHeaderHeight, appRightPadding } from './constants'
import { AppOutsideContainer } from './Common'
import { XDivider, YDivider, useTheme } from 'irmlib/styles' 
import { ClickableSvgIcon, GeneralDrawer, Label, Badge, ContainedButton } from 'irmlib/components/Controls'
// import HelpIcon from '../../icons/svg/help'
// import NotificationIcon from '../../icons/svg/notification'
import DashboardIcon from '../../icons/svg/dashboard'
import AccountCircle from '../../icons/svg/account-circle'
import Close from '../../icons/svg/close'
import IRMlogo from '../../icons/IRM-logo.png'
import { getSlideoutInfo, /* getAppHeaderInfo, */ getDashBoardLinkOn, clickedDashboard, getUser } from '../../redux/global'
import { getSidebarRouteLandingPage } from '../../navigation/sidebarRoutes'
import { doLogout, errorToast, successToast } from '../../common/functions'
import { userRoleAdmin, userRoleSupervisor, userRoleUser, userRoleSuperUser } from '../../common/constants'
// import { gdeWorkerRole } from '../../services/firestore/login'
import i18n from '../../i18n'
import { languageConfig } from '../../services/common/appConstants'
import { useTranslation } from 'react-i18next'
import { MenuItem, Select } from '@mui/material'
import { openGeneralDialog, closeGeneralDialog } from 'irmlib/containers'
import { Autocomplete, CancelButton } from 'irmlib/components/FormControls'
import * as gdeTransactions from './../../services/firestore/gdeTransactions'
import { addCache } from '../../services/firestore/cache'

const appHeaderSlideOutWidth = '250px'
const rightIconXDividerWidth = '30px'
const logoHeight = '50px'

const AppHeaderContainer = styled(AppOutsideContainer)`
  height: ${appHeaderHeight};
  width: 100%;
  align-self: flex-start;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-left: 24px;
  box-shadow: 0px 4px 2px 0px rgba(0,0,0,0.07);
  margin-bottom: 4px;
`

const AppHeaderLeftContainer = styled.div`
  display: flex;
  flex-direction: row;
`

const AppHeaderRightContainer = styled.div`
  display: flex;
  flex-direction: row;
  padding-right: ${appRightPadding};
`

const AppHeaderIconContainer = styled.div`
  margin-top: ${props => props.marginTop || '6px'};
  background-color: 'red';
`

const HeaderRightContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-left: 2px solid ${props => props.theme.palette.primary.main};
`

const AppHeaderSlideOutContainer = styled.div`
  min-width: ${appHeaderSlideOutWidth};
  padding: 20px;
`

const AppHeaderSlideOutTopContainer = styled.div`
  color: ${props => props.theme.palette.primary.main};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  font-size: 15px;
  font-weight: bold;
`

const FlexCenter = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
` 

const UserNameContainer = styled(FlexCenter)`
  font-weight: bold;
`

const SignoutContainer = styled(FlexCenter)`
  color: ${props => props.theme.palette.primary.main};
  font-weight: bold;
  text-decoration: underline;
  cursor: pointer;
`

const HeaderRightIconContainer = styled.div`
  margin-top: 4px;
`

const CloseIconContainer = styled.div`
  margin-top: -20px;
  margin-right: -20px;
`

const LanguageSelect = styled(Select)`
  max-height: 40px;
  margin-top: 10px;
  margin-right: 1rem;
`

const StyledLink = styled(Link)`
  text-decoration: underline;
  font-weight: bold;
  margin-top: 20px;
  margin-right: 20px;
  color: ${props => props.theme.palette.primary.main};
`

const DivCenter = styled('div')`
  display: flex;
  justify-content: center;
`

const CloseButtonTitleStyle = styled('div')`
  font-size: 25px;
  margin-bottom: 15px;
`

// const ContentDialogDiv = styled('div')`
//   padding-right: 30px;
//   padding-left: 30px;
//   padding-bottom: 20px;
// `

// const VerticalDivider = () => <YDivider height="30px" />

const RightIconXDivider = () =>
  <XDivider width={rightIconXDividerWidth} />

const AppHeaderIcon = props => {
  const theme = useTheme()
  return (
    <AppHeaderIconContainer marginTop={props.marginTop}>
      <ClickableSvgIcon 
        onClick={props.onClick}
        disabled={props.disabled}
        title={props.title}
        id={props.id}
      >
        {props.badgeContent
          ? <Badge badgeContent={props.badgeContent}>
            <props.iconComponent scale={0.9} fill={theme.palette.primary.main} />
          </Badge>
          : <props.iconComponent scale={0.9} fill={theme.palette.primary.main} />
}
      </ClickableSvgIcon>
      <RightIconXDivider />
    </AppHeaderIconContainer>
  )
}

AppHeaderIcon.propTypes = {
  onClick: PropTypes.func,
  marginTop: PropTypes.string,
  badgeContent: PropTypes.string,
  disabled: PropTypes.bool,
  title: PropTypes.string,
  id: PropTypes.string,
}

const AppHeaderSlideOut = props => {
  const theme = useTheme()
  const { userRole, userName, userEmail } = useSelector(getSlideoutInfo, shallowEqual)

  const handleClickSignout = useCallback(() => {
    props.handleDrawerClose()
    doLogout()
  }, [])

  let userDisplay = ''
  switch (userRole) {
    case userRoleAdmin:
      userDisplay = 'dashBoard.admin'
      break
    case userRoleSuperUser:
      userDisplay = 'dashBoard.superUser'
      break  
    case userRoleSupervisor:
      userDisplay = 'dashBoard.supervisor'
      break
    case userRoleUser:
      userDisplay = 'dashBoard.dataOperator'
      break
  }


  const stringContainsNumber = (_string) => { 
    const matchPattern = _string.match(/\d+/g)
    if (matchPattern != null) {
      return true
    } else {
      return false
    }
  }

  return (
    <AppHeaderSlideOutContainer>
      <AppHeaderSlideOutTopContainer theme={theme}>
        <Label id={'header-role'}>{userDisplay}</Label>
        <CloseIconContainer>
          <ClickableSvgIcon
            id='header-drawer-close'
            onClick={props.handleDrawerClose}
          >
            <Close scale={1.0} />
          </ClickableSvgIcon>
        </CloseIconContainer>
      </AppHeaderSlideOutTopContainer>
      <YDivider height={'46px'} />
      <FlexCenter>
        <AccountCircle scale={2.7} fill={theme.palette.primary.main} />
      </FlexCenter>
      <YDivider height={'14px'} />
      <UserNameContainer id='header-userName'>
        {userName}
      </UserNameContainer>
      <YDivider height={'10px'} />
      <FlexCenter id='header-userEmail'>
        {stringContainsNumber(userEmail) ? userEmail.split('@')[0] : userEmail}
      </FlexCenter>
      <YDivider height='50px' />
      <SignoutContainer id='header-signout' theme={theme} onClick={handleClickSignout}>
        <Label>
          app.signout
        </Label>
      </SignoutContainer>
    </AppHeaderSlideOutContainer>
  )
}

AppHeaderSlideOut.propTypes = {
  handleDrawerClose: PropTypes.func,
}

const HeaderRight = () => {
  const appHeaderSlideOutRef = useRef(null)
  const theme = useTheme()

  const onClickSlideOut = useCallback(() => {
    appHeaderSlideOutRef.current.open()
  }, [])

  return (
    <HeaderRightContainer theme={theme}>
      <XDivider width='24px' />
      <HeaderRightIconContainer>
        <ClickableSvgIcon id='header-drawer-open' onClick={onClickSlideOut} >
          <AccountCircle scale={0.9} fill={theme.palette.primary.main} />
        </ClickableSvgIcon>
      </HeaderRightIconContainer>
      <GeneralDrawer
        ref={appHeaderSlideOutRef}
        variant='temporary'
        anchor='right'
        drawerContent={props =>
          // eslint-disable-next-line react/prop-types
          <AppHeaderSlideOut handleDrawerClose={props.handleDrawerClose}
        />} 
      />
    </HeaderRightContainer>
  )
}

/**
 * AppHeader is the header for the app.
 * 
 * @param {object} props see AppHeader.propTypes
 * @returns {React.ReactElement} - React AppHeader component
 */
const AppHeader = props => {
  const { t } = useTranslation()
  const [locale, setLocale] = useState(i18n.language)
  i18n.on('languageChanged', (lng) => setLocale(i18n.language))
  const [, setState, getState] = useMergeState({
    buildingData: [],
    buildingId: false,
    countryName: false,
    workingLocation: false,
  })

  const handleChange = (event) => {
    i18n.changeLanguage(event.target.value)
  }

  useEffect(async () => {
    const buildingData = []
    const workerDetailsGde = await gdeTransactions.getWorkerRoleGde(getUser()?.workerId)
    if (workerDetailsGde?.district !== undefined) {
      let countryName = workerDetailsGde?.gdeCountry

      // code if gdeCountry is missing in the workers collection
      if (countryName === undefined) {
        countryName = await gdeTransactions.getCountryForDistrict(workerDetailsGde?.district[0])
      }
      setState({ countryName: countryName })
      const collection = await gdeTransactions.getLocationsForCountry(countryName)
      collection.forEach((doc) => {
        Object.keys(doc.data().buildings).forEach(key => {
          buildingData.push({ 
            value: `${doc.data().districtName}|${doc.data().buildings[key]}`,
            label: `${doc.data().districtName} : ${doc.data().buildings[key]}` 
          })
        })
      })
      addCache('wrokLocation', getUser()?.workerId, workerDetailsGde?.workingLocation)
      setState({ buildingData: buildingData, workingLocation: workerDetailsGde?.workingLocation })
      workerDetailsGde?.workingLocation === undefined && changeBuilding()
    }
  }, [getUser()?.workerId])

  const SelectBuilding = () => {
    return (
      <>
        <Autocomplete
          id={'change_district'}
          label= {t('dashBoard.selectWorkingBuilding')}
          options= {getState()?.buildingData}
          onChange={(e) => onChangeBuildingId(e)}
          noTranslate
        />
      </>
    )
  }

  const ButtonsForUpdateBuilding = (props) => (
    <>
      <CancelButton onClick={props.handleClose}/>
      <XDivider width="10px" />
      <ContainedButton onClick={props.handleSave}>buttons.save</ContainedButton>
    </>
  )

  const handleCloseModal = () => {
    closeGeneralDialog()
    !getState().workingLocation && doLogout()
  }

  const onChangeBuildingId = (e) => {
    if (e) {
      setState({ buildingId: e })
    } else {
      setState({ buildingId: false })
    }
  }

  const handleUpdateBuilding = async() => {
    if (getState().buildingId) {
      const districtIdBuildingId = getState().buildingId.split('|')
      const workingLocation = {
        country: getState()?.countryName,
        district: districtIdBuildingId[0],
        building: districtIdBuildingId[1]
      }
      await gdeTransactions.updateWorkingLocation(getUser()?.workerId, workingLocation)
      addCache('wrokLocation', getUser()?.workerId, workingLocation)
      setState({ workingLocation: workingLocation })
      successToast({ message: t('toast.successBuildingChange'), title: t('toast.success'), autoHideDuration: 3000 })
      closeGeneralDialog()
    } else {
      errorToast({ message: t('dashBoard.selectWorkingBuilding'), title: t('toast.error'), autoHideDuration: 3000 })
    }
  }
  const changeBuilding = (event) => {
    openGeneralDialog({
      title: <DivCenter>
        <CloseButtonTitleStyle>
          <Label>{('dashBoard.selectWorkingBuilding')}</Label>
        </CloseButtonTitleStyle>
      </DivCenter>,
      message: <SelectBuilding />,
      translateMessage: false,
      noTranslateTitle: true,
      buttons: (
        <ButtonsForUpdateBuilding 
          handleClose={handleCloseModal}
          handleSave={handleUpdateBuilding}
        />
      ),
      closeX: false
    })
  }

  const theme = useTheme()
  // const { numNotifications } = useSelector(getAppHeaderInfo, shallowEqual)
  const dashBoardLinkOn = useSelector(getDashBoardLinkOn)
  const history = useHistory()

  const onClickDashboard = () => {
    clickedDashboard()
    history.push(getSidebarRouteLandingPage())
  }

  let selectedLanguage = locale
  if (locale === 'en-US') {
    selectedLanguage = 'en'
  }

  return (
    <AppHeaderContainer theme={theme}>
      <AppHeaderLeftContainer>
        <img height={logoHeight} src={IRMlogo} alt="IRM logo"/>
      </AppHeaderLeftContainer>
      {props.userLoggedIn && <AppHeaderRightContainer>
        <StyledLink id='dashBoard-district' theme={theme} to= '#' onClick={changeBuilding}>
          {getState()?.workingLocation?.building !== undefined ? getState()?.workingLocation?.building : ''}
        </StyledLink>
        <LanguageSelect value={selectedLanguage} onChange={handleChange}>
          {languageConfig.map(({ languageCode, languageLabel }) => 
            <MenuItem key={languageCode} value={languageCode}>{languageLabel}</MenuItem>
          )}
        </LanguageSelect>
        <AppHeaderIcon
          // eslint-disable-next-line no-console
          id='header-gotodashboard'
          onClick={onClickDashboard}
          iconComponent={DashboardIcon}
          disabled={!dashBoardLinkOn}
          title='dashBoard.goToDashboard'
        />
        {/* These may be needed at some later time.
        <AppHeaderIcon
          badgeContent={numNotifications > 0 ? numNotifications.toString() : undefined}
          // eslint-disable-next-line no-console
          onClick={() => console.log('click NotificationIcon')}
          iconComponent={NotificationIcon}
          marginTop='4px'
        />
        <AppHeaderIcon 
          // eslint-disable-next-line no-console
          onClick={() => console.log('click HelpIcon')}
          iconComponent={HelpIcon}
        />
        */}
        <HeaderRight />
      </AppHeaderRightContainer>
      }
    </AppHeaderContainer>
  )
}

AppHeader.propTypes = {
  userLoggedIn: PropTypes.bool,
}

export default AppHeader